import { atom } from "jotai";

export const formulaValues = atom<any | null>(null);
